import { NotificationState } from 'src/modules/notifications/types/NotificationData';
import { RootState } from 'src/types/RootState';

export function getNotification(state: RootState): NotificationState {
  return state.notification;
}
